import type { ReactNode } from "react";

/** The phone's sticky bottom bar: the screen's main actions within thumb reach. Hidden on wider screens. */
export function ActionBar({ children }: { children: ReactNode }) {
  return <div className="actionbar">{children}</div>;
}
